import { axiosInstance } from "./axiosInstance";

export const getSplitBuyDetails = async (identifier) => {
  const { data: response } = await axiosInstance.get("/split-buy/details", {
    params: { slug: identifier },
  });

  if (!response?.status || !response?.data) {
    const message = Array.isArray(response?.message) ? response.message[0] : response?.message;
    throw new Error(message || "The Split-Buy details could not be loaded.");
  }

  return response.data;
};
